export type Individual = {
  firstName?: string
  lastName?: string
  middleName?: string
  organization?: string
  title?: string
  avatar?: string
}
